import {Modal, Button} from 'react-bootstrap'
import {IResourceCenter} from '../../../types/resourceCenter'
import {VideoPreview} from './VideoPreview'
import {prependBackendUrl} from '../../../gql/client'

interface ModalViewResourceProps {
  isOpen: boolean
  onClose: () => void
  resource: IResourceCenter
}

export const ModalViewResource: React.FC<ModalViewResourceProps> = ({isOpen, onClose, resource}) => {
  const isUrl = !!resource.url

  return (
    <Modal show={isOpen} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <i className="bi bi-eye" />
          {resource.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{minHeight: 400}}>
        {isUrl ? (
          <div>
            <VideoPreview url={resource.url!} height={500} />
            {resource.description && (
              <div className="mt-3">
                <strong>Description:</strong>
                <p className="text-muted mb-0">{resource.description}</p>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center">
            <div className="alert alert-info">
              <i className="bi bi-info-circle me-2" />
              This is a file resource. Click the button below to open or download it.
            </div>
            {resource.description && (
              <div className="mb-3 text-start">
                <strong>Description:</strong>
                <p className="text-muted">{resource.description}</p>
              </div>
            )}
            <a
              href={prependBackendUrl(resource.file || '')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              <i className="bi bi-box-arrow-up-right me-2" />
              Open File in New Tab
            </a>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        {isUrl && (
          <Button
            variant="primary"
            onClick={() => window.open(resource.url!, '_blank', 'noopener,noreferrer')}
          >
            <i className="bi bi-box-arrow-up-right me-2" />
            Open in New Tab
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
